import { useEffect, useState } from "react"
import { HorizontalLayout, VerticalLayout } from "../components/layout"

export const TimeBar = ({ time, onTimeUp }) => {
  const [remaining, setRemaining] = useState(time)

  useEffect(() => {
    if (remaining <= 0) {
      if (onTimeUp) onTimeUp()
      return
    }

    const timer = setInterval(() => {
      setRemaining((prev) => prev - 1)
    }, 1000)

    return () => clearInterval(timer)
  }, [remaining, onTimeUp])

  const percentage = Math.max((remaining / time) * 100, 0)

  return (
    <HorizontalLayout
      style={{
        height: "1rem",
        backgroundColor: "var(--grey-100)",
        borderRadius: 1000,
        overflow: "hidden",
        margin: "1rem",
        width: "calc(100% - 2rem)",
      }}
    >
      <div
        style={{
          width: `${percentage}%`,
          height: "100%",
          backgroundColor: percentage > 0 ? "var(--primary-600)" : "var(--error-600)",
          borderRadius: 100,
          transition: "width 1s linear",
        }}
      />
    </HorizontalLayout>
  )
}

export function ProgressBarComplete({ progress = "0%", type = "translate",  direction = "horizontal", barColor= "primary-600"}) {
  const numericProgress = parseFloat(progress);
  const isHorizontal = direction === "horizontal";
  const Container = isHorizontal ? HorizontalLayout : VerticalLayout;
 const barStyle = type === "fill" ? isHorizontal ? { width: `${numericProgress}%`, height: "100%" } : { height: `${numericProgress}%`, width: "100%", alignSelf: "flex-end" } : isHorizontal ? { width: "100%", height: "100%", transform: `translateX(-${100 - numericProgress}%)` } : { width: "100%", height: "100%", transform: `translateY(${100 - numericProgress}%)` };
  

  return (
    <Container
      style={{
        flex: "none",  
        width: isHorizontal ? "100%" : "0.5rem",
        height: isHorizontal ? "0.5rem" : "100%", 
        backgroundColor: "var(--primary-100)",
        borderRadius: 1000,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          ...barStyle,
          borderRadius: 100,
          backgroundColor: `var(--${barColor})`,
          transition: isHorizontal ? "width 0.3s linear" : "height 0.3s linear",
        }}
      />
    </Container>
  );
}